import React, { useEffect, useMemo, useRef, useState } from "react";
import { useNavigate, useLocation, useParams } from "react-router-dom";

import { Month, Day, Year } from "../components/Select";
import { Formik, Form, Field, ErrorMessage } from "formik";
import * as Yup from "yup";
import "./css/SignUp.css";
import { useDispatch, useSelector } from "react-redux";
import {
  addUserData,
  addAssociationData,
  setToken,
  setAssociateId,
} from "../slices/signUp";
import Select from "react-select";
import countries from "../utils/countries_states.json";
import { postCall, getCall } from "../utils/Network";
import { useTranslation } from "react-i18next";
import Enroller from "../components/Enrolloer";
import scrollToTop from "../components/hooks/ScrollToTop";
import Loader from "../components/Loader";
import { toast } from "react-toastify";
import { FaEye, FaEyeSlash } from "react-icons/fa";
import LanguageDropdown from "../components/LanguageDropdown";
import ProgressBar from "../components/ProgressBar";

const ApiKey = process.env.REACT_APP_API_KEY;

function useQuery() {
  return new URLSearchParams(useLocation().search);
}

// Signup component

const Signup = () => {
  const formikRef = useRef();
  let params = useParams();
  const query = useQuery();
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [selectedOption, setSelectedOption] = useState(null);
  const [selectedState, setSelectedState] = useState(null);
  const [aliasCheckLoading, setAliasCheckLoading] = useState(false);
  const [aliasError, setAliasError] = useState("");
  const [isAliasAlreadyExist, setIsAliasAlreadyExist] = useState(false);
  const [ageError, setAgeError] = useState("");
  const associateEmail = query.get("email");
  const [isEnrollChange, setIsEnrollChange] = useState(false);
  const myHeaders = { "API-key": ApiKey };
  const [newEnrollCode, setNewEnrollCode] = useState("");
  const [errorMsg, setErrorMsg] = useState("");
  const [enroller, setEnroller] = useState(null);
  const [isLoading, setIsLoading] = useState(false);
  const { t } = useTranslation();
  const selectedLanguage = localStorage.getItem("language");
  const [showPasswordPopup, setShowPasswordPopup] = useState(false);
  const [passwordValidations, setPasswordValidations] = useState({
    minLength: false,
    maxLength: false,
    hasUppercase: false,
    hasLowercase: false,
    hasNumber: false,
    hasSpecialChar: false,
  });
  const [phoneError, setPhoneError] = useState("");
  const [isOnFirstStep, setIsOnFirstStep] = useState(true);
  const [selectedPhoneCode, setSelectedPhoneCode] = useState(null);
  const [showPassword, setShowPassword] = useState(false);

  const location = useLocation();

  const customStyles = {
    control: (base, state) => ({
      ...base,
      backgroundColor: "rgba(255, 255, 255, 0.11)",
      color: "white",
      height: "45px",
      borderRadius: "10px",
      borderColor: state.isFocused ? "#888" : "#555",
      boxShadow: "none",
      // cursor: state.isDisabled ? "not-allowed" : "pointer",
      // opacity: state.isDisabled ? 0.4 : 1,
      "&:hover": {
        borderColor: "#888",
      },
    }),
    singleValue: (base) => ({
      ...base,
      color: "white",
    }),
    menu: (base) => ({
      ...base,
      zIndex: "9999",
      backgroundColor: "#383a41",
    }),
    option: (base, { isDisabled, isFocused, isSelected }) => ({
      ...base,
      backgroundColor: isFocused ? "gray" : "#383a41",
      color: "white",
      cursor: isDisabled ? "not-allowed" : "pointer",
    }),
    placeholder: (base) => ({
      ...base,
      color: "#aaa",
    }),
  };

  // const customStyles = {
  //     control: (base, state) => ({
  //         ...base,
  //         backgroundColor: "rgba(255, 255, 255, 0.11)",
  //         color: "white",
  //         borderColor: state.isFocused ? "#888" : "#555",
  //         boxShadow: "none",
  //         "&:hover": {
  //             borderColor: "#888"
  //         }
  //     }),
  //     singleValue: (base) => ({
  //         ...base,
  //         color: "white"
  //     }),
  //     menu: (base) => ({
  //         ...base,
  //         backgroundColor: "#383a41",
  //         maxHeight: "160px", // ~5 to 7 items depending on item height
  //         overflowY: "auto",
  //         zIndex: 9999,
  //     }),
  //     option: (base, { isDisabled, isFocused, isSelected }) => ({
  //         ...base,
  //         backgroundColor: isFocused ? "gray" : "#383a41",
  //         color: "white",
  //         cursor: isDisabled ? "not-allowed" : "pointer",
  //     }),
  //     placeholder: (base) => ({
  //         ...base,
  //         color: "#aaa",
  //     }),
  // };

  useEffect(() => {
    const html = document.getElementsByTagName("html")[0];
    html.setAttribute("data-wf-page", "68603f7a056ff6f78f58cb16");
    html.setAttribute("data-wf-site", "68603f7a056ff6f78f58cab1");
    window.Webflow && window.Webflow.destroy();
    window.Webflow && window.Webflow.ready();
    window.Webflow && window.Webflow.require("ix2").init();
    document.dispatchEvent(new Event("readystatechange"));
  }, []);

  useEffect(() => {
    scrollToTop();
  }, []);

  Enroller();

  const validatePassword = (password) => {
    setPasswordValidations({
      minLength: password.length >= 9,
      maxLength: password.length > 0 && password.length < 16,
      hasUppercase: /[A-Z]/.test(password),
      hasLowercase: /[a-z]/.test(password),
      hasNumber: /\d/.test(password),
      hasSpecialChar: /[(!@#$%^&*(),.?\:{ }|<>)]/.test(password),
    });
  };

  const getEnrollerId = JSON.parse(sessionStorage.getItem("enroller"));

  const languageOptions = [
    {
      value: "us",
      label: "US English",
      flagUrl: "/assets/img/69280c3b-4f68-4730-9ff8-744daffc2d64.jpg",
    },
    { value: "es", label: "Spanish", flagUrl: "/assets/img/spain.jpg" },
    { value: "pt", label: "Portuguese", flagUrl: "/assets/img/portugual.jpg" },
    { value: "pl", label: "Polish", flagUrl: "/assets/img/Poland.jpg" },
    { value: "sk", label: "Slovak", flagUrl: "/assets/img/slovakia.jpg" },
    { value: "fr", label: "French", flagUrl: "/assets/img/French.jpg" },

    // Add more languages as needed
  ];

  // Custom Option component to display flags and labels
  const CustomOption = (props) => {
    const { data, innerRef, innerProps } = props;
    return (
      <div
        ref={innerRef}
        {...innerProps}
        style={{ display: "flex", alignItems: "center", marginLeft: "8px" }}
        className="custom-option"
      >
        <img src={data.flagUrl} style={{ width: "30px", marginRight: "8px" }} />
        {data.label}
      </div>
    );
  };

  const CustomSingleValue = (props) => {
    const { data } = props;
    return (
      <div
        className=""
        style={{
          display: "flex",
          alignItems: "center",
          marginLeft: "8px",
          height: "50px",
          marginTop: "2px",
        }}
      >
        <img src={data.flagUrl} style={{ width: "30px", marginRight: "8px" }} />
        {data.label}
      </div>
    );
  };

  useEffect(() => {
    var Senroller = sessionStorage.getItem("enroller");

    if (Senroller) {
      setEnroller(JSON.parse(Senroller));
    }
  }, []);

  //   Calculate Age Function
  function calculateAge(birthDateString) {
    const birthDate = new Date(birthDateString);

    const today = new Date();

    let age = today.getFullYear() - birthDate.getFullYear();

    const monthDifference = today.getMonth() - birthDate.getMonth();

    if (
      monthDifference < 0 ||
      (monthDifference === 0 && today.getDate() < birthDate.getDate())
    ) {
      age--;
    }

    return age;
  }

  const validatePhone = async (phone, phoneCode) => {
    const fullPhoneNumber = `${phoneCode}${phone}`;
    const response = await getCall({
      url: "validatePhone",
      header: myHeaders,
      urlParams: {
        associativeid: 25,
        phone: fullPhoneNumber,
      },
    });
    if (response && response.data) {
      if (response.data.errors && response.data.errors.length > 0) {
        return response.data.errors[0]; // Return the first error message
      }
      if (response.data.errors && response.data.errors.length < 0) {
        return response.data.errors[0]; // Return the first error message
      }
      return response.data.isValid ? "" : t("phoneNumberAlreadyInUse");
    }
    return "";
  };

  // Handle Create Associate Function
  const handleCreateAssociate = async (submittedFormValues) => {
    setIsLoading(true);
    const {
      email,
      password,
      firstname,
      lastname,
      line1,
      line2,
      city,
      zip,
      phone,
      country,
      state,
      agreeTerms,
      month,
      year,
      day,
      webalias,
    } = submittedFormValues;

    let birthDate = `${year}-${month}-${day}`;
    if (day < 10) {
      birthDate = `${year}-${month}-0${day}`;
    }

    const bodyData = {
      firstName: firstname.trim(),
      lastName: lastname.trim(),
      legalFirstName: firstname.trim(),
      legalLastName: lastname.trim(),
      email: email.trim(),
      phone: phone.trim(),
      phoneCode: selectedPhoneCode?.value,
      password: password.trim(),
      birthDate: birthDate,
      externalId: "",
      taxId: "",
      taxResaleNumber: "",
      backOfficeId: "",
      languageCode: selectedLanguage || "en",
      termsIP: "",
      acceptedTerms: agreeTerms,
      userType: "customer",
      associateStatus: "Active",
      enrollerId: getEnrollerId.associateId,
      shippingAddress: [
        {
          line1: line1.trim(),
          line2: line2.trim(),
          state: state.trim(),
          city: city.trim(),
          zip: zip.trim(),
          countryCode: country.trim(),
        },
      ],
      billingAddress: {
        line1: line1.trim(),
        line2: line2.trim(),
        state: state.trim(),
        city: city.trim(),
        zip: zip.trim(),
        countryCode: country.trim(),
      },
      webAlias: [
        {
          enabled: true,
          alias: `${webalias.trim()}`,
        },
      ],
      userName: email.trim(),
    };
    return await postCall({
      url: "createAssociate",
      bodyData,
      header: myHeaders,
    }).then(async (response) => {
      if (response?.status == 200) {
        dispatch(addAssociationData(response?.data));
        dispatch(setAssociateId(response?.data?.associateId));
        localStorage.setItem("associateid", response.data.associateId);

        if (response?.data?.associateId) {
          const data = {
            email: email,
            password: password,
          };

          await generateToken({ email, password }, webalias);
        }
      } else if (
        response?.response.data?.detail &&
        response.response.data.detail.includes("Cannot insert duplicate key")
      ) {
        const duplicateEmail =
          response.response.data.detail.match(/\(([^)]+)\)/)?.[1];
        toast.error(t("email_in_use_error", { email: duplicateEmail }));
      } else {
        toast.error("Something went wrong. Please try again.");
      }

      setIsLoading(false);
    });
  };

  const generateToken = async (data, webAlias) => {
    setIsLoading(true);
    await postCall({
      url: "generateToken",
      bodyData: {
        ...data,
        ...{ clientId: process.env.REACT_APP_API_CLIENTID },
      },
      header: myHeaders,
    }).then((resp) => {
      if (resp?.status == 200) {
        dispatch(setToken(resp?.data.jwtToken));
        localStorage.setItem("apiToken", JSON.stringify(resp.data));
        // navigate(`/${webAlias}/enrollment-kit`);
        window.location.href = `/${webAlias}/enrollment-kit`;
      }
      setIsLoading(false);
    });
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    setAliasError("");
  };

  const validateWebAlias = async (webalias) => {
    setAliasCheckLoading(true);
    if (webalias == "") {
      setAliasError(t("pleaseEnterPersonalReferralCode"));
      return "";
    } else {
      setAliasError("");
    }
    const myHeaders = { "API-key": ApiKey };

    try {
      const response = await getCall({
        url: "validateWebAlias",
        header: myHeaders,
        urlParams: {
          associativeid: 25,
          webAlias: webalias,
        },
      });
      setAliasCheckLoading(false);

      if (response?.data?.isValid) {
        setAliasError(t("aliasAvailable"));
        setIsAliasAlreadyExist(true);
      } else {
        setAliasError(t("aliasAlreadyInUsed"));
        setIsAliasAlreadyExist(false);
      }
    } catch (error) {
      console.error(t("errorCheckingAliasUniqueness"), error);
      setAliasCheckLoading(false);
      return false;
    }
  };

  //COUNTRY FLAGS
  const formatOptionLabel = ({ label, iso2 }) => (
    <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
      <img
        src={`https://flagcdn.com/48x36/${iso2?.toLowerCase()}.png`}
        alt={label}
        style={{
          width: "26px",
          height: "26px",
          borderRadius: "50%",
          objectFit: "cover",
        }}
      />
      <span style={{ color: "white" }}>{label}</span>
    </div>
  );

  const countryOptions = countries?.data
    .filter((item) => item.states?.length > 0)
    .map((item) => {
      return item;
    });
  // Function to handle option selection
  const handleOptionChange = (selectedOption) => {
    setSelectedOption(selectedOption);

    if (selectedOption?.phoneCode) {
      setSelectedPhoneCode({
        value: selectedOption.phoneCode,
        label: selectedOption.phoneCode,
        iso2: selectedOption.iso2,
      });
    }
    setSelectedState(null);
  };

  const phoneCodeOptions = countries.data.map((country) => ({
    value: country.phoneCode,
    label: country.label,
    iso2: country.iso2,
  }));

  //PHONE CODE STYLE
  const formatPhoneOptionLabel = (option, { context }) => {
    if (context === "menu") {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "8px" }}>
          <img
            src={`https://flagcdn.com/48x36/${option.iso2?.toLowerCase()}.png`}
            alt={option.label}
            style={{
              width: "20px",
              height: "20px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <span style={{ color: "white" }}>
            ({option.value}) {option.label}
          </span>
        </div>
      );
    } else {
      return (
        <div style={{ display: "flex", alignItems: "center", gap: "6px" }}>
          <img
            src={`https://flagcdn.com/48x36/${option.iso2?.toLowerCase()}.png`}
            alt={option.label}
            style={{
              width: "18px",
              height: "18px",
              borderRadius: "50%",
              objectFit: "cover",
            }}
          />
          <span style={{ color: "white", padding: "0 2em 0 0" }}>
            {option.value}
          </span>
        </div>
      );
    }
  };

  const phoneSelectStyles = {
    container: (base) => ({
      ...base,
      // width: "120px",
      background: "transparent",
    }),
    control: (base, state) => ({
      ...base,
      height: "48px",
      borderRadius: "10px",
      marginRight: "5px",
      borderColor: state.isFocused ? "#888" : "#555",
      backgroundColor: "rgba(255,255,255,0.1)",
      boxShadow: "none",
      "&:hover": {
        borderColor: "#888",
      },
    }),
    indicatorSeparator: () => ({
      display: "none",
    }),
    option: (base, { isFocused, isSelected, isDisabled }) => ({
      ...base,
      backgroundColor: isFocused ? "gray" : "#383a41",
      color: "white",
      cursor: isDisabled ? "not-allowed" : "pointer",
      padding: "8px 12px",
    }),
    singleValue: (base) => ({
      ...base,
      color: "white",
      display: "flex",
      alignItems: "center",
      gap: "8px",
    }),
    menu: (base) => ({
      ...base,
      width: "200px",
      backgroundColor: "#383a41",
      borderRadius: "6px",
      marginTop: "4px",
      zIndex: 10,
    }),
    placeholder: (base) => ({
      ...base,
      color: "#aaa",
    }),
  };

  // Get phone code based on selected country
  let phoneCode = "";
  if (selectedOption) {
    phoneCode = selectedOption.phoneCode;
  }

  // Set Is Enroll Change Function
  const fnIsChange = () => {
    setIsEnrollChange(true);
  };

  // Set New Enroll Code Function
  const fnSetNewEnrollCode = (e) => {
    setNewEnrollCode(e.target.value);
  };

  // Change Enroll Function

  const fnChangeEnroll = async (e) => {
    e.preventDefault();

    if (newEnrollCode == "") {
      setErrorMsg(t("pleaseEnterEnrollersCode"));
      return;
    }

    const myHeaders = { "API-key": ApiKey };

    try {
      let response = await getCall({
        url: "getAssociateByWebAlias",
        urlParams: { webAlias: newEnrollCode },
        header: myHeaders,
      });

      if (response && response?.data?.associateId) {
        sessionStorage.setItem("enroller", JSON.stringify(response.data));
        setEnroller(response.data);
        setIsEnrollChange(false);
        navigate(
          `/${newEnrollCode}/signupAddress?email=${
            associateEmail ? associateEmail : ""
          }`,
          { replace: true }
        );
      } else {
        setErrorMsg(t("enrollersReferralNotValid"));
        return false;
      }
    } catch (error) {
      console.log(t("errorColon"), error);
    }

    setErrorMsg("");
  };

  // Close Popup Function
  const fnClosePopup = () => {
    setIsEnrollChange(false);
    setNewEnrollCode("");
    setErrorMsg("");
  };

  const getDefaultLanguage = () => {
    const browserLanguage = navigator.language || "en"; // Default to 'en' if navigator.language is unavailable
    const languageCode = browserLanguage.split("-")[0]; // Get the language code (e.g., 'en' from 'en-US')
    return (
      languageOptions.find((option) => option.value === languageCode) ||
      languageOptions[0]
    ); // Default to the first option if not found
  };

  const defaultValue = useMemo(() => getDefaultLanguage(), []);

  const stepOneSchema = Yup.object({
    email: Yup.string()
      .email(t("invalidEmailAddress"))
      .required(t("emailIsRequired")),
    password: Yup.string()
      .min(9, t("passwordMustBeLeast8"))
      .max(15, t("passwordMustLessThan16"))
      .matches(/['A-Z']/, t("passwordMustIncludeUppercase"))
      .matches(/[a-z]/, t("passwordMustIncludeLowercase"))
      .matches(/\d/, t("passwordMustIncludeNumber"))
      .matches(/[(!@#$%^&*(),.?\:{ }|<>)]/, t("passwordMustIncludeSpecialChar"))
      .required(t("passwordIsRequired")),
    firstname: Yup.string().required(t("firstNameIsRequired")),
    lastname: Yup.string().required(t("lastNameIsRequired")),
    webalias: Yup.string()
      .matches(/^[a-zA-Z0-9]+$/, "Only letters and number are allow")
      .min(3, t("aliasMustBeLeast3"))
      .test("", "", function () {
        return isAliasAlreadyExist;
      })
      .required(t("usernameIsRequired")),
    month: Yup.string().required(t("monthIsRequired")),
    day: Yup.string().required(t("dayIsRequired")),
    year: Yup.string().required(t("yearIsRequired")),
  });

  const stepTwoSchema = Yup.object({
    country: Yup.string().required(t("countryIsRequired")),
    state: Yup.string().required(t("stateIsRequired")),
    city: Yup.string().required(t("cityIsRequired")),
    zip: Yup.string().required(t("zipCodeIsRequired")),
    line1: Yup.string().required(t("addressIsRequired")),
    line2: Yup.string(),
    phone: Yup.string()
      .matches(/^[0-9]+$/, t("phoneMustContainNumeric"))
      .required(t("phoneNumberIsRequired")),
    agreeTerms: Yup.bool()
      .oneOf([true], t("pleaseAcceptTheTermsCondition"))
      .required(),
  });

  //Globaly Submit mean singup Few details for next step
  const handleNextStep = async () => {
    const formik = formikRef.current;
    if (!formik) return;

    formik.setTouched({
      email: true,
      password: true,
      firstname: true,
      lastname: true,
      webalias: true,
      month: true,
      day: true,
      year: true,
    });

    const errors = await formik.validateForm();

    if (Object.keys(errors).length === 0) {
      console.log("Form values outside JSX:", formik.values);
      setIsOnFirstStep(false);
    }
  };

  const checkKeyPressSingUp = (e) => {
    if (e?.key === "Enter") {
      handleNextStep();
    }
  };

  const checkKeyPressSubmit = (e) => {
    const submitFormik = formikRef.current;
    if (e?.key === "Enter") {
      submitFormik.submitForm();
    }
  };

  const checkKeyPressEnrollCodeUpdate = (e) => {
    if (e?.key === "Enter") {
      // console.warn("Update Enroll Code API not intigrated.")
    }
  };

  return (
    <>
      {isLoading && <Loader />}
      <div className="enrollment-navbar">
        <div className="noa-logo heading-margin"></div>
        <div>
          <LanguageDropdown />
        </div>
      </div>
      <div className="theme-bg ">
        <div className="signup-card corner-border">
          <ProgressBar currentStep={isOnFirstStep ? "0" : "1"} />

          <div className="heading">
            <h2 className="title-h2 mt-5 mb-2" style={{ color: "white" }}>
              {isOnFirstStep ? t("signUp") : t("addresses")}
            </h2>
            <h4 className="title-h4 mb-3" style={{ color: "white" }}>
              {isOnFirstStep ? t("enterYourAccountInfo") : ""}
            </h4>
          </div>
          <div className="sign-div">
            <div
              style={
                isEnrollChange ? { display: "block" } : { display: "none" }
              }
              className="enroll-fdiv"
            >
              <form onSubmit={fnChangeEnroll}>
                <span onClick={fnClosePopup} className="close-popup">
                  x
                </span>
                {/* <h2 className="mb-0-5 white">{t("welcome")}</h2> */}
                <p className="mb-3 white">{t("enterReferralOfAdvocate")}:</p>
                <div className="chng-div-input">
                  <input
                    type="text"
                    value={newEnrollCode}
                    placeholder={t("enrollersReferralCode")}
                    className="theme-inp"
                    onChange={fnSetNewEnrollCode}
                    onKeyDown={checkKeyPressEnrollCodeUpdate}
                  />

                  <div className="navbar-button-wrapper">
                    <div className="primary-button-wrapper">
                      <a href="#" className="inner-button w-inline-block">
                        <div className="primary-button-border-wrap">
                          <div className="primary-button-wrap">
                            <div className="primary-button-text">
                              {t("update")}
                            </div>
                            <div className="primary-button-hover-text">
                              {t("update")}
                            </div>
                            <div className="primary-button-hover-bg"></div>
                          </div>
                        </div>
                        <div className="line-wrap-inner">
                          <div className="inner-line-wrap _1">
                            <div className="line"></div>
                            <div className="line _2"></div>
                          </div>
                          <div className="inner-line-wrap _2">
                            <div className="line _3"></div>
                            <div className="line _4"></div>
                          </div>
                          <div className="inner-line-wrap _3">
                            <div className="line _5"></div>
                            <div className="line _6"></div>
                          </div>
                          <div className="inner-line-wrap _4">
                            <div className="line _7"></div>
                            <div className="line _8"></div>
                          </div>
                        </div>
                      </a>
                    </div>
                    <div className="menu-button w-nav-button">
                      <div
                        data-is-ix2-target="1"
                        className="hamburger-menu-icon"
                        data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                        data-animation-type="lottie"
                        data-src="/images/hamburger-20menu.lottie"
                        data-loop="0"
                        data-direction="1"
                        data-autoplay="0"
                        data-renderer="svg"
                        data-duration="0"
                        data-ix2-initial-state="0"
                      >
                        <span style={{ color: "#ffffff" }}>
                          <img
                            src="/images/Hamburger_icon.png"
                            alt=""
                            style={{ width: "30%" }}
                          />
                        </span>
                      </div>
                    </div>
                  </div>
                  {/* <button className="sing-up-address-btn">{t("getStarted")} </button> */}
                </div>
                <div className="err-message">
                  <small>{errorMsg}</small>
                </div>
              </form>
            </div>
            {(enroller ?? null) && (
              <div
                className="user-name"
                style={
                  isEnrollChange ? { display: "none" } : { display: "flex" }
                }
              >
                {t("enroller")}: {enroller?.firstName} {enroller?.lastName} (
                {enroller?.webAlias[0]?.alias}) -{" "}
                <div className="conge change-span" onClick={fnIsChange}>
                  {t("change")}
                </div>
              </div>
            )}
            <br />

            <Formik
              innerRef={formikRef}
              initialValues={{
                email: associateEmail ?? "",
                password: "",
                firstname: "",
                lastname: "",
                line1: "",
                line2: "",
                city: "",
                zip: "",
                phone: "",
                country: "",
                state: "",
                agreeTerms: false,
                month: "",
                day: "",
                year: "",
                webalias: "",
                // language: defaultValue.value
              }}
              validationSchema={isOnFirstStep ? stepOneSchema : stepTwoSchema}
              onSubmit={async (values, { isSubmitting, setSubmitting }) => {
                let birthDate = `${values.year}-${values.month}-${values.day}`;
                let age = calculateAge(birthDate);
                console.log(birthDate);
                setAgeError("");
                dispatch(addUserData({ data: values }));
                await handleCreateAssociate(values);
                setSubmitting(false);
              }}
            >
              {({
                isSubmitting,
                values,
                handleBlur,
                setFieldValue,
                setFieldError,
                validateForm,
                setTouched,
                submitForm,
              }) => (
                <Form>
                  {/* {isOnFirstStep ? ( */}
                  <div style={{ display: `${isOnFirstStep ? "" : "none"}` }}>
                    <div className="grid-container">
                      <div className="width_50">
                        <label className="input-title">Email</label>
                        <Field
                          name="email"
                          className="theme-inp"
                          maxLength={50}
                          placeholder={t("email")}
                          type="email"
                          onKeyDown={checkKeyPressSingUp}
                        />
                        <ErrorMessage
                          name="email"
                          component="small"
                          className="block align-left error-message"
                          value={associateEmail}
                        />
                      </div>

                      <div className="width_50 relative">
                        <label className="input-title">{t("Password")}</label>
                        <div className="relative">
                          <Field
                            name="password"
                            className="theme-inp"
                            maxLength={50}
                            onKeyDown={checkKeyPressSingUp}
                            onInput={(e) => {
                              setShowPasswordPopup(true);
                              validatePassword(e.target.value);
                            }}
                            onBlur={() => setShowPasswordPopup(false)}
                            placeholder={t("Password")}
                            type={showPassword ? "text" : "password"}
                          />

                          <button
                            type="button"
                            className="toggle-password-btn"
                            onClick={() => setShowPassword((prev) => !prev)}
                            tabIndex={-1}
                          >
                            {showPassword ? <FaEye /> : <FaEyeSlash />}
                          </button>
                        </div>

                        <ErrorMessage
                          name="password"
                          component="small"
                          className="block align-left error-message"
                        />
                        {showPasswordPopup && (
                          <div className="password-popup">
                            <ul>
                              <li>
                                {passwordValidations.minLength ? "✅" : "❌"}{" "}
                                {t("mustBeAtleast8Character")}
                              </li>
                              <li>
                                {passwordValidations.maxLength ? "✅" : "❌"}{" "}
                                {t("mustBeAtmost16Character")}
                              </li>
                              <li>
                                {passwordValidations.hasUppercase ? "✅" : "❌"}{" "}
                                {t("mustBeAtleastOneUppercase")}
                              </li>
                              <li>
                                {passwordValidations.hasLowercase ? "✅" : "❌"}{" "}
                                {t("mustBeAtleastOneLowercase")}
                              </li>
                              <li>
                                {passwordValidations.hasNumber ? "✅" : "❌"}{" "}
                                {t("mustBeAtleastOneNumber")}
                              </li>
                              <li>
                                {passwordValidations.hasSpecialChar
                                  ? "✅"
                                  : "❌"}
                                {t("mustIncludeAtleastOneSpecialCharacter")}
                              </li>
                            </ul>
                          </div>
                        )}
                      </div>

                      <div className="width_50">
                        <label className="input-title">{t("firstName")}</label>
                        <Field
                          name="firstname"
                          className="theme-inp"
                          maxLength={50}
                          placeholder={t("firstName")}
                          onKeyDown={checkKeyPressSingUp}
                        />
                        <ErrorMessage
                          name="firstname"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>

                      <div className="width_50">
                        <label className="input-title">{t("lastName")}</label>
                        <Field
                          name="lastname"
                          className="theme-inp"
                          maxLength={50}
                          placeholder={t("lastName")}
                          onKeyDown={checkKeyPressSingUp}
                        />
                        <ErrorMessage
                          name="lastname"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>

                      <div className="width_50" style={{ textAlign: "left" }}>
                        <label className="input-title">
                          {t("yourPersonalReferralCode")}
                        </label>

                        <div className="referral-input-text">
                          <span className="referral-input-text-span">
                            <svg
                              xmlns="http://www.w3.org/2000/svg"
                              width="20"
                              height="20"
                              viewBox="0 0 26 26"
                              fill="none"
                              stroke="currentColor"
                              strokeWidth="2"
                              strokeLinecap="round"
                              strokeLinejoin="round"
                              className="icon icon-tabler icons-tabler-outline icon-tabler-info-circle"
                            >
                              <path
                                stroke="none"
                                d="M0 0h24v24H0z"
                                fill="none"
                              />
                              <path d="M3 12a9 9 0 1 0 18 0a9 9 0 0 0 -18 0" />
                              <path d="M12 9h.01" />
                              <path d="M11 12h1v4h1" />
                            </svg>
                          </span>
                          <span className="referral-input-text-p">
                            {t("referalUpperText")}
                          </span>
                        </div>

                        <div className="col-xs-12 col-md-12  input-div">
                          <Field
                            name="webalias"
                            className="theme-inp web-alias"
                            maxLength={50}
                            onKeyDown={checkKeyPressSingUp}
                            onChange={(e) => {
                              const lettersAndNumbers = e.target.value.replace(
                                /[^a-zA-Z0-9]/g,
                                ""
                              );
                              if (/[a-zA-Z]/.test(lettersAndNumbers)) {
                                setFieldValue("webalias", lettersAndNumbers);
                              } else {
                                setFieldValue("webalias", "");
                              }
                            }}
                            onBlur={async (e) => {
                              const alias = e.target.value;
                              if (alias.length < 3) {
                                setAliasError(t("aliasMustBeLeast3"));
                                return;
                              }
                              setAliasError("");
                              setIsAliasAlreadyExist(false);
                              setAliasCheckLoading(true);
                              setIsLoading(true);
                              await validateWebAlias(alias);
                              setIsLoading(false);
                            }}
                            onInput={(e) => handleSubmit(e)}
                            placeholder={t("e.g. johndoe123")}
                          />

                          {isLoading && <Loader />}
                          {!aliasError && (
                            <ErrorMessage
                              name="webalias"
                              component="small"
                              className="block align-left error-message"
                            />
                          )}
                        </div>

                        {aliasError != t("aliasAvailable") && (
                          <small style={{ color: "red", textAlign: "start" }}>
                            {aliasError}
                          </small>
                        )}
                        {aliasError == t("aliasAvailable") && (
                          <small style={{ color: "green", textAlign: "start" }}>
                            {aliasError}
                          </small>
                        )}
                      </div>

                      <div>
                        <label className="input-title">
                          {t("dateOfBirth")}
                        </label>
                        <div className="grid-date marginTop23">
                          <div>
                            <Field
                              component={Day}
                              name="day"
                              cn="day"
                              month={values.month}
                              year={values.year}
                              styles={customStyles}
                              onKeyDown={checkKeyPressSingUp}
                            />
                            <ErrorMessage
                              name="day"
                              component="small"
                              className="block align-left error-message"
                            />
                          </div>
                          <div>
                            <Field
                              className="theme-inp"
                              component={Month}
                              year={values.year}
                              day={values.day}
                              name="month"
                              cn="month"
                              styles={customStyles}
                              onKeyDown={checkKeyPressSingUp}
                            />
                            <ErrorMessage
                              name="month"
                              component="small"
                              className="block align-left error-message"
                            />
                          </div>
                          <div>
                            <Field
                              component={Year}
                              month={values.month}
                              day={values.day}
                              name="year"
                              cn="year"
                              styles={customStyles}
                              onKeyDown={checkKeyPressSingUp}
                            />
                            <ErrorMessage
                              name="year"
                              component="small"
                              className="block align-left error-message"
                            />
                          </div>
                        </div>
                        <small className="block align-left error-message">
                          {ageError}
                        </small>
                      </div>
                    </div>
                    <div className="btn-div-signup">
                      <div className="navbar-button-wrapper">
                        <div className="primary-button-wrapper">
                          <a
                            href="#"
                            className="inner-button w-inline-block"
                            onClick={(e) => {
                              e.preventDefault();
                              handleNextStep();
                            }}
                          >
                            <div className="primary-button-border-wrap">
                              <div className="primary-button-wrap">
                                <div className="primary-button-text">
                                  {!!isSubmitting
                                    ? t("pleaseWaitDot")
                                    : t("next")}
                                  &nbsp;&nbsp;➜
                                </div>
                                <div className="primary-button-hover-text">
                                  {!!isSubmitting
                                    ? t("pleaseWaitDot")
                                    : t("next")}
                                  &nbsp;&nbsp;➜
                                </div>
                                <div className="primary-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap-inner">
                              <div className="inner-line-wrap _1">
                                <div className="line"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="inner-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="inner-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="inner-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                        <div className="menu-button w-nav-button">
                          <div
                            data-is-ix2-target="1"
                            className="hamburger-menu-icon"
                            data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                            data-animation-type="lottie"
                            data-src="/images/hamburger-20menu.lottie"
                            data-loop="0"
                            data-direction="1"
                            data-autoplay="0"
                            data-renderer="svg"
                            data-duration="0"
                            data-ix2-initial-state="0"
                          >
                            <span style={{ color: "#ffffff" }}>
                              <img
                                src="/images/Hamburger_icon.png"
                                alt=""
                                style={{ width: "30%" }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>

                  <div style={{ display: `${isOnFirstStep ? "none" : ""}` }}>
                    <div className="grid-container">
                      {/* BILLING FORM */}
                      {/* <div className="col-xs-12 col-md-12  pb-30">
                                      <h3 className="right-line white">
                                        <span>{t("billingAddress")}</span>
                                        <span className="line"></span>
                                      </h3>
                                    </div> */}

                      <div className="col-xs-12 col-md-12 pb-15">
                        <label className="white pb-1">
                          {t("selectACountry")}
                        </label>

                        <Field name="country">
                          {({ field, form }) => (
                            <>
                              <Select
                                className="country-box"
                                {...field}
                                value={selectedOption}
                                onChange={(selectedOption) => {
                                  handleOptionChange(selectedOption);
                                  form.setFieldValue(
                                    field.name,
                                    selectedOption?.iso2
                                  );
                                  form.setFieldValue("state", "");
                                }}
                                options={countryOptions}
                                placeholder={t("selectACountry")}
                                // onKeyDown={(e) => {
                                //   checkKeyPress(e, "update", submitForm);
                                // }}
                                styles={customStyles}
                                formatOptionLabel={formatOptionLabel}
                              />
                              {form.errors.country && form.touched.country && (
                                <small className="block align-left error-message">
                                  {form.errors.country}
                                </small>
                              )}
                            </>
                          )}
                        </Field>
                      </div>

                      <div className="col-xs-12 col-md-12  pb-15">
                        <label className="white pb-1">
                          {t("selectAState")}
                        </label>
                        <Field name="state">
                          {({ field, form }) => (
                            <>
                              <Select
                                className="state-box"
                                {...field}
                                value={selectedState}
                                onChange={(selectedState) => {
                                  form.setFieldValue(
                                    field.name,
                                    selectedState.value || ""
                                  );
                                  setSelectedState(selectedState);
                                }}
                                options={selectedOption?.states || []}
                                placeholder={t("selectAState")}
                                styles={customStyles}
                                // onKeyDown={(e) => {
                                //   checkKeyPress(e, "update", submitForm);
                                // }}
                              />
                              {form.errors.state && form.touched.state && (
                                <small className="block align-left error-message">
                                  {form.errors.state}
                                </small>
                              )}
                            </>
                          )}
                        </Field>
                      </div>

                      <div className="col-xs-12 col-md-12  pb-15">
                        <label className="white pb-1">
                          {t("addressLine1")}
                        </label>
                        <Field
                          name="line1"
                          className="theme-inp"
                          placeholder={t("addressLine1")}
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />
                        <ErrorMessage
                          name="line1"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>
                      <div className="col-xs-12 col-md-12  pb-15">
                        <label className="white pb-1">
                          {t("addressLine2")}
                        </label>
                        <Field
                          name="line2"
                          className="theme-inp"
                          placeholder={t("addressLine2")}
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />
                        <ErrorMessage
                          name="line2"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>
                    </div>

                    <div className="grid-date">
                      <div className="col-xs-12 col-md-12  pb-15">
                        <label className="white pb-1">{t("city")}</label>
                        <Field
                          name="city"
                          className="theme-inp"
                          maxLength={50}
                          placeholder={t("city")}
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />
                        <ErrorMessage
                          name="city"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>
                      <div className="col-xs-12 col-md-12  pb-15">
                        <label className="white pb-1">{t("zip")}</label>
                        <Field
                          name="zip"
                          className="theme-inp"
                          maxLength={50}
                          placeholder={t("zip")}
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />
                        <ErrorMessage
                          name="zip"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>

                      <div className="col-xs-12 col-md-8  pb-15">
                        <label className="white pb-1">{t("phone")}</label>

                        <div className="row" style={{ display: "flex" }}>
                          <div className="col-xs-2 col-2 span-code-ph">
                            <Select
                              className="phone-code-select"
                              value={selectedPhoneCode}
                              onChange={setSelectedPhoneCode}
                              options={phoneCodeOptions}
                              formatOptionLabel={formatPhoneOptionLabel}
                              placeholder="Code"
                              styles={phoneSelectStyles}
                            />
                          </div>

                          <div
                            className="col-xs-10 col-10 pl-0"
                            style={{ width: "76%" }}
                          >
                            <Field
                              name="phone"
                              className="theme-inp"
                              maxLength={20}
                              placeholder={t("phone")}
                              onKeyDown={(e) => {
                                checkKeyPressSubmit(e);
                              }}
                              onChange={(e) => {
                                const numericValue = e.target.value.replace(
                                  /\D/g,
                                  ""
                                ); // Remove non-digits
                                setFieldValue("phone", numericValue);
                              }}
                              onBlur={async (e) => {
                                handleBlur(e);
                                const phoneValidationError =
                                  await validatePhone(
                                    values.phone,
                                    selectedPhoneCode?.value || ""
                                  );
                                if (phoneValidationError) {
                                  setFieldError("phone", phoneValidationError);
                                  setPhoneError(phoneValidationError);
                                } else {
                                  setPhoneError("");
                                }
                              }}
                            />
                          </div>
                        </div>

                        <ErrorMessage
                          name="phone"
                          component="small"
                          className="block align-left error-message"
                        />
                      </div>
                    </div>

                    <div className="col-xs-12 col-md-8  pb-15">
                      <label className="block align-left mb-2">
                        <Field
                          type="checkbox"
                          name="receiveEmails"
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />{" "}
                        <small className="white">
                          {t("iWouldLikeToReceive")}.
                        </small>
                      </label>

                      <label className="block align-left mb-2">
                        <Field
                          type="checkbox"
                          name="agreeTerms"
                          onKeyDown={(e) => {
                            checkKeyPressSubmit(e);
                          }}
                        />{" "}
                        <small className="white">
                          {t("iAgreeToAllContracts")}.
                        </small>
                        <div style={{ marginLeft: "1rem" }}>
                          <ErrorMessage
                            name="agreeTerms"
                            component="small"
                            className="block align-left error-message"
                          />
                        </div>
                      </label>
                      {/* {(enroller ?? null) && (
                                        <div className="mb-2 white">
                                          {t("enroller")}: {enroller?.firstName}{" "}
                                          {enroller?.lastName} ({enroller?.webAlias[0]?.alias}) -{" "}
                                          <span
                                            className="conge change-span"
                                            onClick={fnIsChange}
                                          >
                                            Change
                                          </span>
                                        </div>
                                      )} */}
                    </div>
                    <div className="btn-div" style={{ position: "relative" }}>
                      <div className="community-spotlight-button-wrapper">
                        <div className="primary-button-wrapper">
                          <a
                            href="#"
                            className="inner-button w-inline-block"
                            onClick={(e) => {
                              e.preventDefault();
                              e.stopPropagation();
                              setIsOnFirstStep(true);
                            }}
                          >
                            <div className="primary-button-border-wrap">
                              <div className="inner-button-wrap">
                                <div className="inner-button-text-wrap">
                                  <div className="inner-button-text">
                                    {t("back")}
                                  </div>
                                  <div className="inner-button-hover-text">
                                    {t("back")}
                                  </div>
                                </div>
                                <div className="inner-button-star-wrap">
                                  <img
                                    loading="lazy"
                                    src="/images/inner-button-star-1.svg"
                                    alt=""
                                    className="inner-button-star _1"
                                  />
                                  <img
                                    loading="lazy"
                                    src="/images/inner-button-star-2.svg"
                                    alt=""
                                    className="inner-button-star _2"
                                  />
                                  <img
                                    loading="lazy"
                                    src="/images/inner-button-star-3.svg"
                                    alt=""
                                    className="inner-button-star _3"
                                  />
                                </div>
                                <div className="inner-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap-inner">
                              <div className="inner-line-wrap _1">
                                <div className="line"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="inner-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="inner-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="inner-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>
                      </div>

                      <div
                        className="navbar-button-wrapper"
                        style={{ position: "absolute", bottom: 0, right: 0 }}
                      >
                        <div className="primary-button-wrapper">
                          <a
                            onClick={(e) => {
                              e.preventDefault();
                              submitForm();
                            }}
                            style={{ cursor: "pointer" }}
                            data-w-id="3af1c84f-ff74-c014-cb3b-40446b73b1f6"
                            className="primary-button w-inline-block"
                          >
                            <div className="primary-button-border-wrap">
                              <div className="primary-button-wrap">
                                <div className="primary-button-text">
                                  {!!isSubmitting
                                    ? t("pleaseWaitDot")
                                    : t("next")}
                                  &nbsp;&nbsp;➜
                                </div>
                                <div className="primary-button-hover-text">
                                  {!!isSubmitting
                                    ? t("pleaseWaitDot")
                                    : t("next")}
                                  &nbsp;&nbsp;➜
                                </div>
                                <div className="primary-button-hover-bg"></div>
                              </div>
                            </div>
                            <div className="line-wrap">
                              <div className="primary-line-wrap _1">
                                <div className="line _1"></div>
                                <div className="line _2"></div>
                              </div>
                              <div className="primary-line-wrap _2">
                                <div className="line _3"></div>
                                <div className="line _4"></div>
                              </div>
                              <div className="primary-line-wrap _3">
                                <div className="line _5"></div>
                                <div className="line _6"></div>
                              </div>
                              <div className="primary-line-wrap _4">
                                <div className="line _7"></div>
                                <div className="line _8"></div>
                              </div>
                            </div>
                          </a>
                        </div>

                        <div className="menu-button w-nav-button">
                          <div
                            data-is-ix2-target="1"
                            className="hamburger-menu-icon"
                            data-w-id="b58e0106-6be1-80f9-2e9e-29cc3a30b8aa"
                            data-animation-type="lottie"
                            data-src="/images/hamburger-20menu.lottie"
                            data-loop="0"
                            data-direction="1"
                            data-autoplay="0"
                            data-renderer="svg"
                            data-duration="0"
                            data-ix2-initial-state="0"
                          >
                            <span style={{ color: "#ffffff" }}>
                              <img
                                src="/images/Hamburger_icon.png"
                                alt=""
                                style={{ width: "30%" }}
                              />
                            </span>
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  {/* )} */}
                </Form>
              )}
            </Formik>
          </div>
        </div>
      </div>
    </>
  );
};

export default Signup;
